














import IconColumnsPicker from '@empathybroker/ebx-gluon/dist/components/pure/columns-picker/icon-columns-picker.vue';
import { Component } from 'vue-property-decorator';

@Component
export default class CdlColumnsPicker extends IconColumnsPicker {}
